<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <div id="checkout">
      <!-- Checkout inserts the payment form here -->
    </div>
    
  </b-overlay>
</template>

<script>
import {BModal, BButton, BOverlay, BRow, BCol, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BModal,
    BButton,
    BRow,
    BCol
  },
  data() {
    return {
      subscriptions:[],
      subscription:null,
      pageLength: 3,
      totalRows:0,
      currentPage:1,
      dir: false,
      loading:true,
      selectedItem:null,
      columns: [
        {
          label: 'Code',
          field: 'code',
        },
        {
          label: 'Nom',
          field: 'name',
        },
        {
          label: 'Montant',
          field: 'amount',
        },
        {
          label: 'Action',
          field: 'action',
        }
        
      ],
      rows: [],
      searchTerm: '',

    }
  },
  watch:{
    
  },
  methods:{
   
  },
  async mounted()
  {
    const stripe = Stripe('pk_test_51Ix7q2BGInQvVcEzPCh5bh4SVvsT3uAMwIB9bMqdesgZyQnsDeyAkFuVukFRiKKAELjWRkj8HRqKTwo9CnNTGoUI001k8WNdy2');



    let checkout_session=await APIRequest.createCheckoutSession(this.$route.params.id)

    this.client_secret=checkout_session.data.client_secret

 
    // Initialize Checkout
    const checkout = await stripe.initEmbeddedCheckout({
      clientSecret: this.client_secret,
    });

    // Mount Checkout
    checkout.mount('#checkout');
 
    this.loading=false
  }
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-good-table.scss';
.subscription-price
{
  font-size:30px;
}
.subscription-row {
  margin: 0 -10px;
}

.subscription-col {
  padding: 10px;
}
</style>
